module.exports = __webpack_public_path__ + "img/green-caret-up.890f2085.svg";